import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-health-card-back-side',
  templateUrl: './health-card-back-side.component.html',
  styleUrls: ['./health-card-back-side.component.css']
})
export class HealthCardBackSideComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
